import React from 'react';

import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import TermsAndConditions from '../components/termsAndConditions/TermsAndConditions';

const termsAndConditions = () => {
    return (
        <div>
            <Header />
            <TermsAndConditions />
            <Footer />
        </div>
    );
};

export default termsAndConditions;


// WEBPACK FOOTER //
// ./src/pages/termsAndConditions.js